import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import type { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { CircleAlert } from 'lucide-react-native'
import type { AdminAuthStackParamList } from '../../../navigation/types'
import { Button } from '@chillout/ui'
import { AdminAuthLayout } from './AdminAuthLayout'
import { AuthScreenHeader } from './AuthScreenHeader'
import { BackToSignInLink } from './BackToSignInLink'
import { clearAdminAuthUrl } from './authUrl'

export function AdminResetLinkErrorScreen() {
  const { t } = useTranslation()
  const navigation = useNavigation<NativeStackNavigationProp<AdminAuthStackParamList>>()

  function handleRequestNewLink() {
    clearAdminAuthUrl()
    navigation.navigate('ForgotPassword')
  }

  function handleBackToSignIn() {
    clearAdminAuthUrl()
    navigation.navigate('SignIn')
  }

  return (
    <AdminAuthLayout>
      <AuthScreenHeader
        Icon={CircleAlert}
        iconAccessibilityLabel={t('adminAuth.resetLinkErrorIconAccessibilityLabel')}
        title={t('adminAuth.resetLinkErrorTitle')}
        subtitle={t('adminAuth.resetLinkErrorSubtitle')}
      />
      <View className="mt-8 w-full sm:mt-10">
        <Button
          label={t('adminAuth.requestNewLinkButton')}
          onPress={handleRequestNewLink}
        />
        <BackToSignInLink
          onPress={handleBackToSignIn}
          className="mt-6"
        />
      </View>
    </AdminAuthLayout>
  )
}
